import React from 'react';
import ContactUsContainer from '../../../Containers/UserContainer/ContactUs';
const ContactUsScreen = () => {
  return <ContactUsContainer />;
};

export default ContactUsScreen;
